import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e4595dec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4595dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4595dec')) {
      api.createRecord('e4595dec', component.options)
    } else {
      api.reload('e4595dec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e4595dec&scoped=true", function () {
      api.rerender('e4595dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shoppingGift/tljPromotionposition/index.vue"
export default component.exports